import { render } from "./CollectionCardTeen.vue?vue&type=template&id=e86119ec"
import script from "./CollectionCardTeen.vue?vue&type=script&lang=js"
export * from "./CollectionCardTeen.vue?vue&type=script&lang=js"

import "./CollectionCardTeen.vue?vue&type=style&index=0&id=e86119ec&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__